import React from 'react'
import { host, path } from '@Api'
const { onlineService } = path

const image = 'https://img.8891.com.tw/next'

const HelpPopover: React.FunctionComponent = () => (
  <div className="tc-top-nav-right-popover help">
    <ul className="help-list">
      <li className="help-list-item">
        <a onClick={() => { window.open(onlineService, 'serviceWindow', 'width=800,height=600') }}>
          <img className="help-list-icon" src={`${image}/header/icon_1.png`} alt="聯絡客服" />
          <p className="help-list-text">聯絡客服</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://www.8891.com.tw/help-index.html" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_2.png`} alt="新手指南" />
          <p className="help-list-text">新手指南</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://www.8891.com.tw/help-index.html" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_3.png`} alt="賣車步驟" />
          <p className="help-list-text">賣車步驟</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://www.8891.com.tw/help-price.html" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_14.png`} alt="收費標準" />
          <p className="help-list-text">收費標準</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://www.8891.com.tw/help-d_1.html" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_4.png`} alt="付款方式" />
          <p className="help-list-text">付款方式</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://www.8891.com.tw/member-index.html" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_5.png`} alt="會員中心" />
          <p className="help-list-text">會員中心</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://c.8891.com.tw/ads/apply" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_12.png`} alt="廣告合作" />
          <p className="help-list-text">廣告合作</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://businessadmin.8891.com.tw/ad/view" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_15.png`} alt="名單廣告" />
          <p className="help-list-text">名單廣告</p>
        </a>
      </li>
      <li className="help-list-item">
        <a href="https://bbs.8891.com.tw/" target="_blank">
          <img className="help-list-icon" src={`${image}/header/icon_13.png`} alt="汽車社群" />
          <p className="help-list-text">汽車社群</p>
        </a>
      </li>
    </ul>
  </div>
)

export default HelpPopover
